import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/home/request-quote.webp'
import _imports_1 from '@/assets/home/request-quote-dark.webp'
import _imports_2 from '@/assets/icons/email_white.svg'
import _imports_3 from '@/assets/icons/location_white.svg'
import _imports_4 from '@/assets/icons/email.svg'
import _imports_5 from '@/assets/icons/phone.svg'


const _hoisted_1 = {
  class: "w-web-panel mx-auto relative md:mb-64 max-w-full md:max-w-[95%]",
  id: "quote-div"
}
const _hoisted_2 = { class: "md:flex max-w-[440px] relative hidden" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  class: "w-full"
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  class: "w-full"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col-reverse text-white gap-10 mt-auto\"><div class=\"flex flex-col gap-5\"><div class=\"flex gap-3\"><img src=\"" + _imports_2 + "\" class=\"w-5 h-5\"><div class=\"text-sm\">info@perfectgreen.ca</div></div><div class=\"flex gap-3\"><img src=\"" + _imports_3 + "\" class=\"w-5 h-5\"><div class=\"text-sm\"></div></div></div><div class=\"font-bold font-georgian text-[24px]\"> Call or text us at<br>+1 (905) 674-5983 </div></div>", 1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-[24px] font-bold leading-normal hidden md:block" }, [
  /*#__PURE__*/_createTextVNode(" Call or text us at "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" +1 (905) 674-5983 ")
], -1)
const _hoisted_8 = {
  key: 0,
  src: _imports_2
}
const _hoisted_9 = {
  key: 1,
  src: _imports_4
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm" }, "info@perfectgreen.ca", -1)
const _hoisted_11 = { class: "flex gap-4 md:hidden" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "h-16 w-16"
}, null, -1)
const _hoisted_13 = { class: "flex flex-col gap-2.5" }

import DropDown from "@/components/common/form/drop-down.vue";
import DefaultInput from "@/components/common//form/default-input.vue";
import FilledButton from "./filled-button.vue";
import Alert from "@/components/common/alert.vue";
import { computed, nextTick, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'request-quote-form',
  props: ["mode"],
  setup(__props) {

const props = __props;
const formData = ref({
  service: "",
  name: "",
  email: "",
  phone: "",
});
const validation = ref({
  hasError: false,
  message: "",
});
const mode = computed(() => {
  return props.mode || "normal";
});

const dropDownOptions = [
  "Artificial Grass - No pet",
  "Artificial Grass - Pet Friendly",
  "Putting Green",
];
const validateForm = () => {
  if (formData.value.service === "") {
    validation.value.hasError = true;
    validation.value.message =
      "Please select the service you are interested in.";
  } else if (formData.value.name === "") {
    validation.value.hasError = true;
    validation.value.message = "Please enter your name.";
  } else if (formData.value.email === "") {
    validation.value.hasError = true;
    validation.value.message = "Please enter your email address.";
  } else if (formData.value.phone === "") {
    validation.value.hasError = true;
    validation.value.message = "Please enter your phone number.";
  } else if (!checkEmail(formData.value.email)) {
    validation.value.hasError = true;
    validation.value.message = "Please enter correct email address.";
  }
  // else if (!isPhoneNumberValid(formData.value.phone)) {
  //   validation.value.hasError = true;
  //   validation.value.message = "Please enter correct phone number.";
  // }
};
const onServiceSelected = (selectedOption: string) => {
  onInput("service", selectedOption);
};
const onInput = (key: keyof typeof formData.value, val: string) => {
  formData.value[key] = val;
};
const checkEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

const onSubmit = async () => {
  validation.value.hasError = false;
  await nextTick();
  validateForm();
  if (!validation.value.hasError) {
    sendFormData();
  }
};
const sendFormData = async () => {
  const url = "https://api.amirayachts.com/perfect-green";
  // const urlDev = "http://localhost:3000/perfect-green";
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData.value),
    });

    if (response.ok) {
      location.href = "/#thankyou";
    } else {
      validation.value = {
        hasError: true,
        message: "Something went wrong Please try again.",
      };
    }
  } catch (error) {
    validation.value = {
      hasError: true,
      message: "Something went wrong Please try again.",
    };
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (mode.value === 'normal')
          ? (_openBlock(), _createElementBlock("img", _hoisted_3))
          : _createCommentVNode("", true),
        (mode.value === 'dark')
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["md:hidden bg-[url(@/assets/request-quote-mobile.webp)] w-full aspect-[375/480] bg-cover flex flex-col px-7 py-9 max-w-full", {
        'bg-[url(@/assets/request-quote-mobile.webp)]': mode.value === 'normal',
        'bg-[url(@/assets/home/request-quote-dark.webp)]': mode.value === 'dark',
      }])
      }, _hoisted_6, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["w-full md:w-[440px] md:absolute top-24 right-0", {
        'bg-white sm:shadow-[8px_24px_34px_0_#a5a3a333]': mode.value === 'normal',
        'bg-[#333333]': mode.value === 'dark',
      }])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["p-7 md:p-10 flex flex-col gap-8", {
          'text-white': mode.value === 'dark',
          'text-green': mode.value === 'normal',
        }])
        }, [
          _hoisted_7,
          _createElementVNode("div", {
            class: _normalizeClass(["flex-col gap-2.5 hidden md:flex", {
            'text-white': mode.value === 'dark',
            'text-[#333333]': mode.value === 'normal',
          }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex gap-2.5", {
              'text-white': mode.value === 'dark',
              'text-green': mode.value === 'normal',
            }])
            }, [
              (mode.value === 'dark')
                ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                : _createCommentVNode("", true),
              (mode.value === 'normal')
                ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                : _createCommentVNode("", true),
              _hoisted_10
            ], 2)
          ], 2),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", {
              class: _normalizeClass(["text-[22px] font-bold font-georgian leading-normal", {
              'text-white': mode.value === 'dark',
              'text-secondary-gray': mode.value === 'normal',
            }])
            }, " Or enter your info, and we’ll call you ", 2)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", {
              class: _normalizeClass(["text-primary-gray text-sm hidden md:block", {
              'text-white': mode.value === 'dark',
              'text-secondary-gray': mode.value === 'normal',
            }])
            }, " Or enter your info, and we’ll call you ", 2),
            _createVNode(DropDown, {
              mode: mode.value,
              placeholder: "Service you're interested in",
              options: dropDownOptions,
              value: formData.value.service,
              onInput: onServiceSelected
            }, null, 8, ["mode", "value"]),
            _createVNode(DefaultInput, {
              placeholder: "Your name",
              type: "name",
              mode: mode.value,
              onInput: _cache[0] || (_cache[0] = (e) => onInput('name', e.target.value))
            }, null, 8, ["mode"]),
            _createVNode(DefaultInput, {
              placeholder: "Your email",
              type: "email",
              mode: mode.value,
              onInput: _cache[1] || (_cache[1] = (e) => onInput('email', e.target.value))
            }, null, 8, ["mode"]),
            _createVNode(DefaultInput, {
              type: "phone",
              placeholder: "Your phone number",
              mode: mode.value,
              onInput: _cache[2] || (_cache[2] = (e) => onInput('phone', e.target.value))
            }, null, 8, ["mode"])
          ]),
          _createVNode(FilledButton, {
            onClick: onSubmit,
            color: "green"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Submit")
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            class: _normalizeClass(["text-[12px] font-normal font-georgian leading-normal italic", {
            'text-white': mode.value === 'dark',
            'text-secondary-gray': mode.value === 'normal',
          }])
          }, " * We take customer privacy seriously and do not sell or give out any customer information. We do not keep a mailing list nor distribute a newsletter. ", 2)
        ], 2)
      ], 2)
    ]),
    (validation.value.hasError)
      ? (_openBlock(), _createBlock(Alert, { key: 0 }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(validation.value.message), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})